'use strict';

var request = require('request');

var path = require('path');

var fs = require('fs');

var onError = function onError(err, done) {
  if (done) {
    return done(err);
  }

  throw err;
};

var downloader = function downloader() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!options.url) {
    throw new Error('The options.url is required');
  }

  if (!options.dest) {
    throw new Error('The options.dest is required');
  }

  options = Object.assign({
    extractFilename: true
  }, options);
  var done = options.done;
  delete options.done;
  options.encoding = null;
  request(options, function (err, res, body) {
    if (err) {
      return onError(err, done);
    }

    if (body && (res.statusCode === 200 || res.statusCode === 201)) {
      if (options.extractFilename) {
        if (!path.extname(options.dest)) {
          var url = require('url');

          var pathname = url.parse(options.url).pathname;
          var basename = path.basename(pathname);
          var decodedBasename = decodeURIComponent(basename);
          options.dest = path.join(options.dest, decodedBasename);
        }
      }

      fs.writeFile(options.dest, body, 'binary', function (err) {
        if (err) {
          return onError(err, done);
        }

        if (typeof done === 'function') {
          done(false, options.dest, body);
        }
      });
    } else {
      if (!body) {
        return onError(new Error("Image loading error - empty body. URL: ".concat(options.url)), done);
      }

      onError(new Error("Image loading error - ".concat(res.statusCode, ". URL: ").concat(options.url)), done);
    }
  });
};

downloader.image = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise(function (resolve, reject) {
    options.done = function (err, dest, body) {
      if (err) {
        return reject(err);
      }

      resolve({
        filename: dest,
        image: body
      });
    };

    downloader(options);
  });
};

module.exports = downloader;